import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { appInsightConfig } from "shared/app-config";
import { tokenStore } from "core/authentication";

const browserHistory = createBrowserHistory({ basename: "" });
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: appInsightConfig.APPINSIGHTS_KEY,
    maxBatchInterval: 0,
    disableFetchTracking: false,
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
    disableAjaxTracking: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});
appInsights.loadAppInsights();
appInsights.addTelemetryInitializer((envelope) => {
  envelope.tags["ai.cloud.role"] = "platform-UI"; 
});
updateAppInsightsUserInformation();

function updateAppInsightsUserInformation() {
  if (appInsights?.setAuthenticatedUserContext) {
    const userData = tokenStore.getUserInfo();
    if (userData && userData.userDetail) {
      appInsights.setAuthenticatedUserContext(userData.userDetail.email);
      appInsights.context.user.id = userData.userDetail.email;
    }
  }
}

function clearAppInsights() {
  if (appInsights?.clearAuthenticatedUserContext) {
    appInsights.clearAuthenticatedUserContext();
    appInsights.context.user.id = "";
    deleteCookies(["ai_session", "ai_user"]);
  }
}

function deleteCookies(cookieNames) {
  cookieNames.forEach((cookieName) => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  });
}

export { reactPlugin, appInsights, updateAppInsightsUserInformation, clearAppInsights };
